import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import API_URL from '../apiconfig';
import axios from './api';
import { auth, storage } from '../firebase';

interface ImageInput {
  id: string;
  url: string;
  path: string;
}

export const getSizeOptions = async () => {
  try {
    const allOptions = await axios.get(`${API_URL}/v1/choices/tattoo`);

    const sizeOptions = allOptions.data.result.filter(
      (option: any) => option.category === 'TATTOO_SIZE',
    );

    return sizeOptions;
  } catch (error) {
    throw new Error('Cannot get size options');
  }
};

export const getServices = async () => {
  try {
    const allOptions = await axios.get(`${API_URL}/v1/choices/tattoo`);

    const sizeOptions = allOptions.data.result.filter(
      (option: any) => option.category === 'TATTOO_SIZE',
    );

    return sizeOptions;
  } catch (error) {
    throw new Error('Cannot get services');
  }
};

export const getPiercingLocations = async () => {
  try {
    const piercingLocations = await axios.get(
      `${API_URL}/v1/choices/piercing-locations`,
    );

    return piercingLocations.data.result;
  } catch (error) {
    throw new Error('Cannot get piercing locations');
  }
};

export const uploadFiles = async (
  images: ImageInput[],
  {
    onSuccess,
  }: {
    onSuccess?: (image: ImageInput) => void;
  } = {},
) => {
  const user = auth.currentUser;
  const authServiceId = user?.uid;
  if (!authServiceId) throw new Error('Not authenticated');

  const transferPromises: Promise<string>[] = [];

  for (let i = 0; i < images.length; i += 1) {
    const image = images[i];

    const response = await fetch(image.url as URL | RequestInfo);
    const blob = await response.blob();

    transferPromises.push(
      new Promise((resolve, reject) => {
        const storageUrl = image.path;
        const permanentImageRef = ref(storage, storageUrl);
        const uploadTask = uploadBytesResumable(permanentImageRef, blob);
        uploadTask.on(
          'state_changed',
          () => {},
          uploadError => reject(uploadError),
          async () => {
            // delete from idb if upload is successful
            onSuccess?.(image);
            const downloadURL = await getDownloadURL(permanentImageRef);
            resolve(downloadURL);
          },
        );
      }),
    );
  }

  const imgUrls = await Promise.all(transferPromises);
  return imgUrls;
};
